import * as React from 'react';
import {enhance} from './enhancer';
import {BansForm} from './../../../components/Bans';
import {setState} from './stete';
import {handler} from './handler';

function Create(props: any) {
  const state = setState();

  return (
    <div className="a__bans-create">
      <div className="b__title c__after-title">
        <h1>禁止ワードを追加する</h1>
      </div>
      <div className="b__form">
        <BansForm create {...{...props, ...state, ...handler}} />
      </div>
    </div>
  );
}

export default enhance((props: any) => <Create {...props} />);
